// extracted by mini-css-extract-plugin
export var label = "locationKeyValue-module--label--e8924";
export var labelWrapper = "locationKeyValue-module--labelWrapper--bfedb";
export var locationKeyValue = "locationKeyValue-module--locationKeyValue--42784";
export var svgWrapper = "locationKeyValue-module--svgWrapper--4a30f";
export var value = "locationKeyValue-module--value--13e7c";